import { logger as browserLogger } from '@/logger/logger.browser';

export async function checkEligibility(emailToken: string, email: string) {
  try {
    const resp = await fetch('/api/checkEligibility', {
      method: 'POST',
      body: JSON.stringify({ email, emailToken }),
    });
    const response = await resp.json();
    return response;
  } catch (error) {
    browserLogger.warn('Error calling checkEligibility', {
      emailToken,
      error,
    });
  }
}
